<template>
  <div v-if="showBasketIcon">
    <div class="notifications" style="z-index: 10; overflow: visible;">

      <drop-down ref="dropdown" :position="'dropdown-menu-left'" style="display: block;" @toggled="basketToggled">
        <template v-slot:button>
          <a id="order-basket-button" href="javascript:void(0)" :title="$t('basket.title_plain')"></a>

        </template>
        <div class="notification-list" @click.stop>
          <div class="container-fluid">
            <div class="row mt-2">
              <div class="col">
                <h3> {{ $t('basket.title', {0: totalQuantity}) }}</h3>
                <hr class="ruler" />
              </div>
            </div>
            <div v-if="isLoaded" class="row">
              <div class="col-12" v-if="count > 0">
                <p class="font-italic">{{ $t('basket.lastadded') }}</p>
              </div>
              <div class="col">
                <div class="row mb-2" v-for="(item, index) in orderLines" :key="index">
                  <div class="col-auto" v-show="item.OrderLineType !== 4">
                    <img class="img-fluid" width="50px" height="50px" :src="item.ImageUrl" />
                  </div>
                  <div class="col">
                    <p class="mb-0">{{ item.Descr }}</p>
                    <p class="mb-0 font-italic" v-if="item.ComposedArticles && item.ComposedArticles.length > 0">{{ $t('basket.composed', {0: item.ComposedArticles.length }) }}</p>
                  </div>
                  <div class="col-auto" v-show="item.OrderLineType !== 4">
                    <a class="btn btn-sm"  :class="{ 'btn-outline-danger': item.OrderQuantity === 1, 'btn-outline-secondary' : item.OrderQuantity > 1 }" @click="decreaseQuantity(item)" href="javascript:void(0)">-</a>
                    <span class="font-weight-bold quantity text-center d-inline-block">{{ item.OrderQuantity }}</span>
                    <a class="btn btn-sm btn-outline-secondary" @click="increaseQuantity(item)" href="javascript:void(0)">+</a>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center py-5" v-if="count === 0">
                {{ $t('basket.basket_empty') }}
              </div>
            </div>
            <page-loader v-else />
            <div class="row my-2">
              <div class="col align-self-end">
                <loading-button :btn-class="'btn btn-outline-secondary'" class="w-100 mb-2" :title="$t('basket.show')" :href="basketDetail" />
              </div>
            </div>
          </div>
        </div>
      </drop-down>
      
      <span class="notification-count badge badge-pill badge-primary mr-1">{{ totalQuantity }}</span>
    </div>

  </div>
</template>

<script>
import DropDown from '@/components/DropDown.vue';
import { geturi } from 'libs/utils.js';
import BasketDetailController from '@/controller/basketdetailcontroller';
import PageLoader from '@/components/PageLoader.vue';
import { Orders } from 'libs/classes/security';
const controller = new BasketDetailController();

export default {
  components: {
    'drop-down': DropDown,
    'page-loader': PageLoader
  },
  data () {
    return {
      count: '',
      orderLines: [],
      showBasketIcon: false,
      isLoaded: false
    };
  },
  async beforeMount() {
    this.showBasketIcon = await this.$authorize([Orders.Orders.Read,Orders.Orders.CreateOrUpdate, Orders.AccessToBaskets]);
    await this.updateOrderState();
    
    //todo fixen naar UpdateOrderState
    window.UpdateOrderState2 = this.updateOrderState;
  },
  methods: {
    async updateOrderState () {
      if (!this.showBasketIcon) return;
      try {
        let data = await controller.GetActiveBasketInfo();
        if (data) {
          this.orderId = data.OrderID;
          this.count = data.Quantity;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async basketToggled (open){
      this.updateOrderState();
      if (open && this.orderId > 0) {
        try {
          let data = await controller.GetOrderLines(this.orderId, '', 5, 0);
          if (data) {
            this.isLoaded = true;
            this.orderLines = data.OrderLines;
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        this.isLoaded = true;
      }
    },
    async updateQuantity(item, newQuantity) {
      try {
        let result = await controller.UpdateOrderLineQuantity(item.AutoID, newQuantity);
        if (result) {
          if (newQuantity == 0) {
            await this.basketToggled (true);
          } else {
            item.OrderQuantity = result.Quantity;
          }
        }
      } catch(error) {
        console.error(error);
      }
    },
    increaseQuantity (item) {
      this.updateQuantity(item, item.OrderQuantity + 1);
    },
    decreaseQuantity(item) {
      this.updateQuantity(item, item.OrderQuantity - 1);
    },
  },
  computed: {
    totalQuantity () {
      return this.count;
    },
    basketDetail () {
      return geturi('frontoffice/basket');
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'styles/settings.scss';
@import './dropdown.scss';
</style>
